// extracted by mini-css-extract-plugin
export var footer = "_q2-0";
export var inherit = "_q2-1";
export var input = "_q2-2";
export var modalContent = "_q2-3";
export var quillEditor = "_q2-4";
export var subtitle = "_q2-5";